import { z } from "zod";

/**
 * Espejo de `GuardarFacturacionRequest`: seis obligatorios y dos opcionales.
 *
 * Lo comparten el portal del cliente y la pantalla de aceptación: es UNA
 * decisión (qué hace válida una factura) y con dos copias el cliente podría
 * pasar por una puerta y rebotar en la otra, igual que en el servidor.
 *
 * NO valida el dígito verificador del RUT, a propósito. Duplicar el módulo 11
 * en el navegador sería un segundo lugar donde se decide qué RUT es válido, y
 * el día que discrepen mandaría el del servidor igual. Acá se comprueba que
 * haya algo escrito; el 422 se pinta sobre el campo cuando llega.
 */
export const facturacionSchema = z.object({
  rut: z.string().trim().min(1, "Ingresa el RUT de la empresa o persona a facturar."),
  razon_social: z.string().trim().min(1, "Ingresa la razón social."),
  giro: z.string().trim().min(1, "Ingresa el giro."),
  direccion: z.string().trim().min(1, "Ingresa la dirección de facturación."),
  comuna_codigo: z.string().min(1, "Elige la comuna."),
  email_facturacion: z
    .string()
    .trim()
    .min(1, "Ingresa el correo al que enviamos la factura.")
    .email("Escribe un correo válido."),
  telefono: z.string().trim(),
  contacto_nombre: z.string().trim(),
});

export type FacturacionValues = z.infer<typeof facturacionSchema>;

export const FACTURACION_VACIA: FacturacionValues = {
  rut: "",
  razon_social: "",
  giro: "",
  direccion: "",
  comuna_codigo: "",
  email_facturacion: "",
  telefono: "",
  contacto_nombre: "",
};
